
<template>
  <div class="form-group d-flex flex-wrap flex-md-nowrap align-items-end gap-2">
    <select
      id="selclient"
      v-model="selectClient"
      class="form-select-sm select-month form-select"
      style="width:160px;"
      @change="onClientChange"
    >
      <option
        v-for="client in clientList"
        :key="client.clientcode"
        :value="client"
      >
        {{ client.clientname }}
      </option>
    </select>

    <select
      v-if="settype === 'search'"
      id="seldevice"
      v-model="selectedDevice"
      class="form-select-sm select-month form-select"
      style="width:160px;"
      @change="onDeviceChange"
    >
      <option
        v-for="device in deviceList"
        :key="device.deviceid"
        :value="device"
      >
        {{ device.devicename }}
      </option>
    </select>

    <!-- 시작일 -->
    <Datepicker
      v-if="settype === 'search'"
      id="startSelectedDate"
      v-model="startSelectedDate"
      style="width:250px;"
      :input-class="'custom-datepicker-input'"
      format="yyyy-MM-dd"
      :max-date="endSelectedDate ?? undefined"
    />

    <!-- 종료일 -->
    <Datepicker
      v-if="settype === 'search'"
      id="endSelectedDate"
      v-model="endSelectedDate"
      style="width:250px;"
      :input-class="'form-select form-select-sm select-month'"
      format="yyyy-MM-dd"
      :min-date="startSelectedDate ?? undefined"
    />
    <button
      id="search"
      type="button"
      class="btn btn-falcon-primary btn-sm"
      @click="onSearch"
    >
      검색
    </button>
  </div>
</template>

<script setup lang="ts">
// import moment from 'moment'
import { onMounted, ref} from 'vue';
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import type { User, Client, Device } from '@/types/commontypes'


const clientList = ref<Client[]>([])
const deviceList = ref<Device[]>([])

const selectClient = ref<Client>({
    clientcode:'',
    clientname:'',
    clientlevel:0,
    servicestate:0,
    regdt:''
})
const selectedDevice= ref<Device>({
        dcode: '',
        deviceid: '',
        clientcode: '',
        devicename: '',
        svlist: '[]',
        regdt: '',
        config: '',
        alertconfig: '',
        configdt: '',
        configuse: 0,
        df1_status: 0, df2_status: 0, df3_status: 0, df4_status: 0, df5_status: 0,
        df6_status: 0, df7_status: 0, df8_status: 0, df9_status: 0, df10_status: 0,
        df11_status: 0, df12_status: 0, df13_status: 0, df14_status: 0, df15_status: 0,
        df16_status: 0, df17_status: 0, df18_status: 0, df19_status: 0, df20_status: 0,
        df21_status: 0, df22_status: 0, df23_status: 0, df24_status: 0, df25_status: 0,
        df26_status: 0, df27_status: 0, df28_status: 0, df29_status: 0, df30_status: 0
})

const startSelectedDate = ref<Date | null>(null)
const endSelectedDate = ref<Date | null>(null) 

let calldeviceid: string | null = "";


interface Props {
  user: User,
  settype: string
}


const { user, settype } = defineProps<Props>()

const emit = defineEmits<{
    (e: 'update:client', value: Client | null): void;
    (e: 'update:device', value: Device | null): void;
    (e: 'update:start', value: Date | null): void;
    (e: 'update:end', value: Date | null): void;
    (e:'search'): void
}>();

onMounted(() => {
    const today = new Date()
    const weekAgo = new Date()
    weekAgo.setDate(today.getDate() - 7)

    // 필요한 경우 포맷을 맞춰서 할당할 수도 있음
    startSelectedDate.value = weekAgo
    endSelectedDate.value = today

   LoadClientList(user, 'selclient', true);
})


function LoadClientList(userjson:User, render:string, bloaddevice:boolean) {
	if(!userjson)
		return;

	var clientid = "all";
	var clientlevel = 1;
	if(userjson.clientlevel == 0) {
		clientid = 'all';
		clientlevel = 1;
	} else {
		clientid = userjson.clientcode;
		clientlevel = 1;
	}

	// 입력값을 변수에 담고 문자열 형태로 변환
	const data = JSON.stringify({ 'operator': "getClientlist", 'clientid' : clientid, 'clientlevel' : clientlevel});
	
	// content-type을 설정하고 데이터 송신
	var xhr = new XMLHttpRequest();
	xhr.open('POST', '/ajax/ajaxcall');
	xhr.setRequestHeader('Content-type', "application/json");
	xhr.send(data);

	// 데이터 수신이 완료되면 표시
	xhr.addEventListener('load', function(){
		let result: Client[] = JSON.parse(xhr.responseText);
		// result = JSON.parse(result);

        result.sort((a, b) => {
            const a1 = a.clientname.toLowerCase();
            const b1 = b.clientname.toLowerCase();
            if (a1 < b1) return -1;
            if (a1 > b1) return 1;

            return 0;
        });


        clientList.value = [];
		for(let client of result) {
		    if(render) {
                clientList.value.push(client);
            }
		}

		// 초기 측정기 리스트 로딩
		if( clientList.value.length > 0) {
            if(!calldeviceid) {
                // localStorage에서 저장된 client 정보 가져오기
                const savedClientCode = localStorage.getItem('selectedClientCode');
                let initialClient = clientList.value[0];

                // 저장된 client가 있고, 현재 리스트에 존재하면 해당 client 선택
                if (savedClientCode) {
                    const foundClient = clientList.value.find(c => c.clientcode === savedClientCode);
                    if (foundClient) {
                        initialClient = foundClient;
                    }
                }

                selectClient.value = initialClient;
                emit('update:client', selectClient.value);
			    //selectedClientCode.value = clientList.value[0].clientcode;
                //console.log("selectCliendCode : ", selectedClientCode.value)
                LoadDeviceList(initialClient.clientcode,  bloaddevice);
            } else {
                //LoadCallDeviceProcess();
            }
		}
	});
}

function onClientChange() {
    const selClientCode = selectClient.value.clientcode;

    // localStorage에 선택된 client 저장
    localStorage.setItem('selectedClientCode', selClientCode);

    LoadDeviceList(selClientCode,  true);

    emit('update:client', selectClient.value);
}

function onDeviceChange() {
    emit('update:device', selectedDevice.value);
    emit('update:start', startSelectedDate.value);
    emit('update:end', endSelectedDate.value);

    emit('search');
}

function LoadDeviceList(clientcode:string, bshowdevicelist:boolean) {
	// 입력값을 변수에 담고 문자열 형태로 변환
	const data = JSON.stringify({ 'operator': "getDevicelist", 'clientcode' : clientcode});
   
	// content-type을 설정하고 데이터 송신
	var xhr = new XMLHttpRequest();
	xhr.open('POST', '/ajax/ajaxcall');
	xhr.setRequestHeader('Content-type', "application/json");
	xhr.send(data);

	// 데이터 수신이 완료되면 표시
	xhr.addEventListener('load', function(){
		let result: Device[] = JSON.parse(xhr.responseText);
		const sortResult = result.sort((a, b) => a.devicename.localeCompare(b.devicename));

        deviceList.value = [];

        if(settype === 'monitor') {
            let addObj:Device = {
                dcode: '',
                deviceid: '',
                clientcode: '',
                devicename: '',
                svlist: '[]',
                regdt: '',
                config: '',
                alertconfig: '',
                configdt: '',
                configuse: 0,
                df1_status: 0, df2_status: 0, df3_status: 0, df4_status: 0, df5_status: 0,
                df6_status: 0, df7_status: 0, df8_status: 0, df9_status: 0, df10_status: 0,
                df11_status: 0, df12_status: 0, df13_status: 0, df14_status: 0, df15_status: 0,
                df16_status: 0, df17_status: 0, df18_status: 0, df19_status: 0, df20_status: 0,
                df21_status: 0, df22_status: 0, df23_status: 0, df24_status: 0, df25_status: 0,
                df26_status: 0, df27_status: 0, df28_status: 0, df29_status: 0, df30_status: 0
            }
            deviceList.value.push(addObj)
        }

		for(let device of sortResult) {
			deviceList.value.push(device);
		}

		if(deviceList.value.length > 0) {
            if(bshowdevicelist) {
                // 외부로 부터 호출되는 deviceid 여부 확인
                if(!calldeviceid) {
                    // load 된 디바이스 리스트를 기준으로 측정값 리스트 검색 기능 처리
                    selectedDevice.value = deviceList.value[0]
                    emit('update:device', selectedDevice.value);

                    emit('update:start', startSelectedDate.value);
                    emit('update:end', endSelectedDate.value);

                    emit('search');
                }
            }
		}
	});
}

// 검색 버튼 처리
function onSearch() {
    // doSearch(1);
    emit('update:device', selectedDevice.value);
    emit('update:start', startSelectedDate.value);
    emit('update:end', endSelectedDate.value);

    emit('search');
}

</script>

<style>
/* Datepicker의 모든 input 요소에 강제 적용 - 최대한 구체적으로 */
</style>

<style scoped>
/* scoped 스타일에서 :deep() 사용 */

</style>

<style>
/* 글로벌 스타일로 Datepicker input 강제 적용 */


/* 모든 Datepicker input 요소 */
div[id^="startSelectedDate"] input,
div[id^="endSelectedDate"] input,
#startSelectedDate input,
#endSelectedDate input {
  font-size: 14px !important;
  height: 29px !important;
  line-height: 23px !important;
}
</style>